// src/components/legal/AvisoCookies.jsx
//
// EL AVISO DE COOKIES (LEGAL.md, L3)
//
// NSL no rastrea: no hay analítica ni publicidad, y el servidor no pone cookies
// propias. Por eso este aviso INFORMA y no finge un «aceptar / rechazar»: no
// hay nada que rechazar, y unos botones que no deciden nada son peores que no
// tenerlos. Si algún día entra un píxel de anuncios, este componente pasa a
// pedir permiso de verdad y nada se carga hasta que la persona acepte.
//
// Sale en las pantallas públicas —donde llega quien no conoce NSL— y no encima
// de los muros de la aplicación, que ya ocupan la pantalla entera.
//
// Lo que el botón hace es recordar en ESTE navegador que ya lo leíste, con la
// versión del documento: si la política cambia, se vuelve a enseñar.

import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './AvisoCookies.css';

const CLAVE = 'nsl_cookies_leido';
const VERSION = '2026-09-cookies-v1';

// Las pantallas públicas. Un visitante entra por aquí; dentro de la app ya
// aceptó los términos al registrarse y el aviso solo estorbaría.
const PUBLICAS = new Set([
  '/', '/landing', '/business', '/plans', '/profesores', '/diagnostico',
  '/login', '/register', '/bienvenida', '/verify-email', '/forgot-password',
  '/reset-password',
]);
// En las páginas legales NO sale: ahí abajo está su propia barra («Volver»,
// «Acepto y continúo») y dos barras peleándose por el mismo sitio es justo el
// estorbo que este aviso no debe ser. Además, quien está leyendo /cookies ya
// está leyendo esto mismo con detalle.

function yaLoLeyo() {
  try { return localStorage.getItem(CLAVE) === VERSION; } catch { return false; }
}

function temaGuardado() {
  try { return localStorage.getItem('theme') === 'light' ? 'light' : 'dark'; } catch { return 'dark'; }
}

export default function AvisoCookies() {
  const { pathname } = useLocation();
  const [oculto, setOculto] = useState(yaLoLeyo);
  const [tema, setTema] = useState(temaGuardado);

  // El tema se elige en otra pantalla (la landing, el menú): al cambiar de
  // ruta se vuelve a leer para no quedarse con el de antes.
  useEffect(() => { setTema(temaGuardado()); }, [pathname]);

  // Mientras el aviso está abajo, la página deja ese hueco libre. Sin esto la
  // barra tapa justo lo último de la pantalla — y lo último del pie es la
  // leyenda legal, que es adonde el propio aviso manda.
  const visible = !oculto && PUBLICAS.has(pathname);
  useEffect(() => {
    document.body.classList.toggle('con-aviso-cookies', visible);
    return () => document.body.classList.remove('con-aviso-cookies');
  }, [visible]);

  if (!visible) return null;

  function entendido() {
    try { localStorage.setItem(CLAVE, VERSION); } catch { /* modo privado */ }
    setOculto(true);
  }

  return (
    <aside className="ck-aviso" data-tema={tema} data-prueba="aviso-cookies"
      role="region" aria-label="Aviso de cookies">
      <p className="ck-texto">
        NSL solo guarda en tu navegador lo necesario para funcionar: tu sesión y tus
        preferencias. <strong>No usamos publicidad ni herramientas de rastreo.</strong>
      </p>
      <div className="ck-botones">
        <Link className="ck-enlace" to="/cookies">Ver detalles</Link>
        <button type="button" className="ck-btn" onClick={entendido}>Entendido</button>
      </div>
    </aside>
  );
}
